import { render } from "./TitleScreen.vue?vue&type=template&id=fa71ecd4&scoped=true"
import script from "./TitleScreen.vue?vue&type=script&lang=js"
export * from "./TitleScreen.vue?vue&type=script&lang=js"

import "./TitleScreen.vue?vue&type=style&index=0&id=fa71ecd4&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-fa71ecd4"

export default script